// extracted by mini-css-extract-plugin
export default {"container":"RichEditorTest_container__aHvB1"};